import React, { useMemo } from 'react'
import { useNewTranslation } from 'hooks'
import { useSelector } from 'react-redux'
import { useFormikContext } from 'formik'
import { selectTaskPlatformContentTypesByName } from 'state/constants'
import styled from 'particles/themes/styled'
import BaseDivider from '../../PredefinedTaskEditor/BaseDivider'
import EngagementMetricsInput from '../../PredefinedTaskEditor/EngagementMetricsInput'
import ExtraTextEditor from '../../PredefinedTaskEditor/ExtraTextEditor'
import { EditorContentCardContainer } from '../../PredefinedTaskEditor/styles'
import { EditorValues } from '../types'
import { CAMPAIGN_STATUS_ENUM, selectEditingCampaign } from 'state/campaigns'
import InputField from 'components/Shared/Fields'
import Text from 'particles/Text'
import CampaignEditorInputFieldContainer from 'components/Shared/Permission/CampaignEditorInputFieldContainer'
import { fieldIdentifiers } from 'components/Shared/Comment'

const StepEditorContainer = styled(EditorContentCardContainer)`
    max-width: 594px;
`
interface CustomEngagementStepEditorProps {
    className?: string
    stepIndex: number
    stepUuid: string
}
const CustomEngagementStepEditor: React.FC<CustomEngagementStepEditorProps> = ({ stepIndex, className, stepUuid }) => {
    const [t] = useNewTranslation()
    const { values: formikValues } = useFormikContext<EditorValues>()
    const taskPlatformContentTypesByName = useSelector(selectTaskPlatformContentTypesByName)
    const campaign = useSelector(selectEditingCampaign)
    const isCampaignLive = Boolean(campaign && campaign.status === CAMPAIGN_STATUS_ENUM.LIVE)
    const engagementType = useMemo(() => {
        return formikValues.platform_content_type
            ? taskPlatformContentTypesByName[formikValues.platform_content_type].engagement_types
            : []
    }, [taskPlatformContentTypesByName])
    const stepNumber = stepIndex + 1

    return (
        <StepEditorContainer className={className}>
            <div className="step-title">
                <Text scale="bodyL700" color="primary">
                    {t('campaignEditor.createTask.listOutSteps.addRequirementProofEngagementCustomTaskHeader')}
                </Text>
                <Text scale="bodyS400" color="secondary">
                    {t('campaignEditor.createTask.addRequirementProofEngagementCustomTaskSubtext', {
                        stepNumber,
                    })}
                </Text>
            </div>
            <CampaignEditorInputFieldContainer>
                <InputField.TextInputField
                    label={t('campaignEditor.createTask.enterStepTitleHeader')}
                    placeholder={t('campaignEditor.createTask.enterTitleHeader')}
                    name={`steps[${stepIndex}].data.title`}
                    isRequired
                    width={'100%'}
                    identifier={`${stepUuid}_${fieldIdentifiers.stepTitle}`}
                />
            </CampaignEditorInputFieldContainer>

            <BaseDivider />

            <div className="section">
                <Text scale="bodyM700" color="primary">
                    {t('campaignEditor.createTask.selectEngagementMetricsHeader')}
                </Text>

                <div>
                    <CampaignEditorInputFieldContainer>
                        <EngagementMetricsInput
                            name={'payouts.engagementMetrics'}
                            engagementTypes={engagementType}
                            stepType={formikValues.steps[stepIndex].type}
                            isReadOnly={isCampaignLive ? isCampaignLive : undefined}
                            identifier={`${stepUuid}_${fieldIdentifiers.engagementMetrics}`}
                        />
                    </CampaignEditorInputFieldContainer>
                    <BaseDivider />
                    <CampaignEditorInputFieldContainer>
                        <ExtraTextEditor name={`steps[${stepIndex}].data.extra_data`} isRequired />
                    </CampaignEditorInputFieldContainer>
                </div>
            </div>
        </StepEditorContainer>
    )
}

export default CustomEngagementStepEditor
